module.exports = __webpack_public_path__ + "media/200420_1500_WSUV_Litbuero_IndenWind_fertig.8e6d5307.mp3";